import { clsx } from 'clsx';
import * as React from 'react';
import * as styles from './Icon.css';
import { getIcon } from './utils';

interface IIconProps {
  name: string;
  className?: string;
}

export const Icon = (props: IIconProps) => {
  const { name, className } = props;

  return (
    <span
      className={clsx(styles['icon'], className)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={getIcon(name)}
      data-mark={`icon|${name}`}
    />
  );
};
